import { History, Message } from '@mui/icons-material';
import {
  type ForumLinkResponse,
  type ThreadLatestPostResponse,
} from '@on3/api';
import { Link } from '@on3/ui-lib/components/Link';
import { toFriendlyDate } from '@on3/ui-lib/utils/date';
import { formatNumber } from '@on3/ui-lib/utils/formatters';
import clsx from 'clsx';

import styles from './PostFeedItem.module.scss';

interface IPostFeedItemProps extends ThreadLatestPostResponse {
  forum?: ForumLinkResponse;
  isModule?: boolean;
}

export const PostFeedItem = ({
  forum,
  isModule,
  ...props
}: IPostFeedItemProps) => {
  const {
    title,
    url,
    lastPostDate,
    lastPostAuthorUsername,
    threadAuthorUsername,
    threadDate,
    replyCount,
    viewCount,
  } = props;

  return (
    <Link href={url}>
      <article
        className={clsx(styles.block, {
          [styles.module]: isModule,
        })}
        data-ui="feed-post"
      >
        {!!forum?.title && <span className={styles.forum}>{forum.title}</span>}
        <h3 className={styles.title}>{title}</h3>
        <div className={styles.meta}>
          <div className={styles.postDetails}>
            <span>by {threadAuthorUsername}</span>
            <span className={styles.date}>{toFriendlyDate(threadDate)}</span>
            <dl className={styles.postCount}>
              <dt>Post count:</dt>
              <dd>
                <Message />
                {replyCount}
              </dd>
            </dl>
          </div>
          <div className={styles.additionalDetails}>
            <dl className={styles.latestActivity}>
              <dt>Latest activity:</dt>
              <dd>
                <span data-module="false">
                  {toFriendlyDate(lastPostDate)} by {lastPostAuthorUsername}
                </span>
                <span
                  data-module="true"
                  title={`Latest activity ${toFriendlyDate(lastPostDate)}`}
                >
                  <History />
                  {toFriendlyDate(lastPostDate)}
                </span>
              </dd>
            </dl>
            <dl className={styles.viewCount}>
              <dt>View count:</dt>
              <dd>{formatNumber(viewCount)} views</dd>
            </dl>
          </div>
        </div>
      </article>
    </Link>
  );
};
